@if (error) {
    <div class="notification ap-padding-bottom-2">
        <ap-notification [status]="getStatus(error)" [closeable]="true" (closeClicked)="hideNotification()">
            <ap-content key="{{ getMessage(error) }}"> </ap-content>
        </ap-notification>
    </div>
}
